import { TIME_ZONES } from "../consts/TIME_ZONES";

export function getTimeZoneByName(timeZoneName: string | undefined) {
  return TIME_ZONES.find((time) => time.name === timeZoneName)
    ?.currentTimeFormat;
}
